import { render } from "./MessageError.vue?vue&type=template&id=a4033010&scoped=true&ts=true"
import script from "./MessageError.vue?vue&type=script&lang=ts"
export * from "./MessageError.vue?vue&type=script&lang=ts"

import "./MessageError.vue?vue&type=style&index=0&id=a4033010&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4033010"]])

export default __exports__